export default {
    wallet: "Carteira",
    "rock-content-credits": "Rock créditos",
    "selected-wallet": "Carteira selecionada",
    "select-wallet": "Selecionar carteira",
    "credits-about-to-expire": "Créditos próximos de vencer",
    "transaction-statements": "Transações",
    "all-transactions-carried": "Todas as transações da sua carteira",
    "all-transactions": "Todas as transações",
    "no-transactions": "Sem transações",
    edded: "Adicionado",
    spent: "Gasto",
    date: "Data",
    credits: "Créditos",
    description: "Descrição",
};
